import styled from 'styled-components/macro'
import { rem, media, color } from '../../utils/styles'
import H1 from '../H1'

const SectionTitle = styled(H1).attrs({
  size: 'small'
})`
  border-bottom: ${rem(1)} solid ${color('base')};
  padding-bottom: ${rem(20)};

  &[data-section] {
    position: relative;
    padding-left: ${rem(30)};

    ${media('desktop')`
      padding-left: ${rem(50)};
    `}

    &::before{
      content: attr(data-section);
      position: absolute;
      left: 0;
    }
  }
`

export default SectionTitle
